const jwt = require('jsonwebtoken')
const users = require('../models').users
const ex = require('../lib/error')

const userAuth = async (req, res, next) => {
    next();
    
        // const token = req.header("x-auth-token");
        // if (!token) {
        //     return ex.raiseError(req, res, "MAUD008", 400, "No token, authorization failed")
        // }
        // try {
        //     const decoded = jwt.verify(token, process.env.SALT);
        //     req.userid = decoded.userid;
        //     req.mobileNo = decoded.mobileNo;

        //     users.findOne({ where: { userid: req.userid, mobileNo: req.mobileNo } })
        //         .then(userdata => {
        //             if (userdata === null)
        //                 return ex.raiseError(req, res, "MAUD008", 400, "No user found")
        //             next()
        //         })
        //         .catch(error => {
        //             ex.raiseError(req, res, 'MAUD008', 500, error)
        //             next()
        //         })

        // } catch (error) {
        //     return ex.raiseError(req, res, "MAUD008", 500, error)
        // }
}

module.exports = {
    userAuth
}